import { Popconfirm as AntdPopConfirm } from 'antd';

const PopConfirm = (props) => {
  const { title = '', description = '', child = <></>, onConfirm = () => {} } = props;

  return (
    <AntdPopConfirm title={title} description={description} onConfirm={onConfirm}>
      {child}
    </AntdPopConfirm>
  );
};
export default PopConfirm;
